<template>
  <div class="rounded bg-white shadow-md">
    <div v-if="content.loading" class="px-8 pt-8">
      <content-placeholders class="w-full">
        <content-placeholders-text class="w-full mb-2" :lines="1" />
        <content-placeholders-img class="w-full mb-6" />
        <content-placeholders-text class="w-full mb-2" :lines="1" />
        <content-placeholders-img class="w-full mb-6" />
        <content-placeholders-text class="w-full mb-2" :lines="1" />
        <content-placeholders-img class="w-full mb-6" />
        <content-placeholders-text
          v-if="dealType == 'International'"
          class="w-full mb-2"
          :lines="1"
        />
        <content-placeholders-img
          v-if="dealType == 'International'"
          class="w-full mb-6"
        />
      </content-placeholders>
      <div class="flex flex-wrap -mx-3 mb-4">
        <content-placeholders class="w-full md:w-1/3 px-3 md:mb-0">
          <content-placeholders-text class="w-full mb-2" :lines="1" />
          <content-placeholders-img class="w-full" />
        </content-placeholders>
        <content-placeholders class="w-full md:w-1/3 px-3 md:mb-0">
          <content-placeholders-text class="w-full mb-2" :lines="1" />
          <content-placeholders-img class="w-full" />
        </content-placeholders>
        <content-placeholders class="w-full md:w-1/3 px-3 md:mb-0">
          <content-placeholders-text class="w-full mb-2" :lines="1" />
          <content-placeholders-img class="w-full" />
        </content-placeholders>
      </div>
    </div>
    <form v-if="content.success" class="px-8 pt-8">
      <div class="flex flex-wrap -mx-3 mb-4">
        <div class="w-full px-3">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-account-name"
          >
            Contact Name
          </label>
          <input
            v-model="contactFullName"
            class="appearance-none block w-full text-gray-700 rounded py-3 px-4 mb-2 leading-tight outline-none bg-white border-gray-500"
            id="grid-account-name"
            readonly
          />
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-4">
        <div class="w-full px-3">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-account-name"
          >
            Account Name
          </label>
          <input
            v-model="form.account.name"
            class="appearance-none block w-full text-gray-700 rounded py-3 px-4 mb-2 leading-tight outline-none bg-white border-gray-500"
            id="grid-account-name"
            readonly
          />
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-4">
        <div class="w-full px-3">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-billing-street"
          >
            Billing Street
          </label>
          <input
            v-model="form.billingAddress.street"
            :class="{
              'border-gray-200': !$v.form.billingAddress.street.$invalid,
              'border-red-500': $v.form.billingAddress.street.$invalid,
              'focus:border-gray-500': !$v.form.billingAddress.street.$invalid,
              'focus:border-red-500': $v.form.billingAddress.street.$invalid
            }"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-2 leading-tight focus:outline-none focus:bg-white"
            id="billing-street"
            type="text"
            placeholder="340 Main Street"
            autocomplete="off"
          />
          <p
            v-if="!$v.form.billingAddress.street.required"
            class="text-red-500 text-xs italic"
          >
            Please fill out this field.
          </p>
          <p
            v-if="!$v.form.billingAddress.street.minLength"
            class="text-red-500 text-xs italic"
          >
            This field must have at least 3 characters.
          </p>
          <p
            v-if="!$v.form.billingAddress.street.maxLength"
            class="text-red-500 text-xs italic"
          >
            This field must have at least 100 characters.
          </p>
        </div>
      </div>
      <div v-if="dealType == 'International'" class="flex flex-wrap -mx-3 mb-4">
        <div class="w-full px-3">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-billing-country"
          >
            Billing Country
          </label>

          <div class="relative mb-2">
            <select
              v-model="form.billingAddress.country"
              :class="{
                'border-gray-200': !$v.form.billingAddress.country.$invalid,
                'border-red-500': $v.form.billingAddress.country.$invalid,
                'focus:border-gray-500': !$v.form.billingAddress.country
                  .$invalid,
                'focus:border-red-500': $v.form.billingAddress.country.required
              }"
              class="block appearance-none w-full bg-gray-200 border text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white"
              id="grid-billing-country"
            >
              <option disabled :value="null">-Select-</option>
              <option
                v-for="option in options.countries"
                :key="option.value"
                :value="option.value"
                >{{ option.label }}</option
              >
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>

          <!-- <input
            v-model="form.billingAddress.country"
            :class="{
              'border-gray-200': !$v.form.billingAddress.country.$invalid,
              'border-red-500': $v.form.billingAddress.country.$invalid,
              'focus:border-gray-500': !$v.form.billingAddress.country.$invalid,
              'focus:border-red-500': $v.form.billingAddress.country.$invalid
            }"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-2 leading-tight focus:outline-none focus:bg-white"
            id="billing-country"
            type="text"
            placeholder="Billing Country"
            autocomplete="off"
          /> -->
          <p
            v-if="!$v.form.billingAddress.country.required"
            class="text-red-500 text-xs italic"
          >
            Please fill out this field.
          </p>
        </div>
        <div class="w-full px-3">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-billing-country"
          >
            End Use Country
          </label>

          <div class="relative mb-2">
            <select
              v-model="form.billingAddress.end_use_country"
              class="block appearance-none w-full bg-gray-200 border text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white"
              id="grid-billing-end_use_country"
            >
              <option value="">-Select-</option>
              <option
                v-for="option in options.countries"
                :key="option.value"
                :value="option.value"
                >{{ option.label }}</option
              >
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-4">
        <div class="w-full md:w-1/3 px-3 md:mb-0">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-billing-city"
          >
            Billing City
          </label>
          <input
            v-model="form.billingAddress.city"
            :class="{
              'border-gray-200': !$v.form.billingAddress.city.$invalid,
              'border-red-500': $v.form.billingAddress.city.$invalid,
              'focus:border-gray-500': !$v.form.billingAddress.city.$invalid,
              'focus:border-red-500': $v.form.billingAddress.city.$invalid
            }"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded mb-2 py-3 px-4 leading-tight focus:outline-none focus:bg-white"
            id="grid-billing-city"
            type="text"
            placeholder="Los Angeles"
            autocomplete="off"
          />
          <p
            v-if="!$v.form.billingAddress.city.required"
            class="text-red-500 text-xs italic"
          >
            Please fill out this field.
          </p>
          <p
            v-if="!$v.form.billingAddress.city.minLength"
            class="text-red-500 text-xs italic"
          >
            This field must have at least 2 characters.
          </p>
          <p
            v-if="!$v.form.billingAddress.city.maxLength"
            class="text-red-500 text-xs italic"
          >
            This field must have at least 30 characters.
          </p>
        </div>
        <div
          v-if="dealType == 'International'"
          class="w-full md:w-1/3 px-3 md:mb-0"
        >
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-billing-state"
          >
            Billing State <small>(optional)</small>
          </label>
          <input
            v-model="form.billingAddress.state"
            :class="{
              'border-gray-200': !$v.form.billingAddress.state.$invalid,
              'border-red-500': $v.form.billingAddress.state.$invalid,
              'focus:border-gray-500': !$v.form.billingAddress.state.$invalid,
              'focus:border-red-500': $v.form.billingAddress.state.$invalid
            }"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded mb-2 py-3 px-4 leading-tight focus:outline-none focus:bg-white"
            id="grid-billing-state"
            type="text"
            placeholder="California"
            autocomplete="off"
          />
          <p
            v-if="!$v.form.billingAddress.state.minLength"
            class="text-red-500 text-xs italic"
          >
            This field must have at least 2 characters.
          </p>
          <p
            v-if="!$v.form.billingAddress.state.maxLength"
            class="text-red-500 text-xs italic"
          >
            This field must have at least 30 characters.
          </p>
        </div>
        <div
          v-else-if="dealType == 'Domestic'"
          class="w-full md:w-1/3 px-3 md:mb-0"
        >
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-billing-state"
          >
            Billing State/Providence
          </label>
          <div class="relative mb-2">
            <select
              v-model="form.billingAddress.state"
              :class="{
                'border-gray-200': !$v.form.billingAddress.state.$invalid,
                'border-red-500': $v.form.billingAddress.state.$invalid,
                'focus:border-gray-500': !$v.form.billingAddress.state.$invalid,
                'focus:border-red-500': $v.form.billingAddress.state.$invalid
              }"
              class="block appearance-none w-full bg-gray-200 border text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white"
              id="grid-billing-state"
            >
              <option disabled :value="null">-Select-</option>
              <optgroup label="United States">
                <option
                  v-for="option in domesticStates('United States')"
                  :key="option.value"
                  :value="option.value"
                  >{{ option.label }}</option
                >
              </optgroup>
              <optgroup label="Canada">
                <option
                  v-for="option in domesticStates('Canada')"
                  :key="option.value"
                  :value="option.value"
                  >{{ option.label }}</option
                >
              </optgroup>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/3 px-3 md:mb-0">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-billing-zip"
          >
            Billing Zip
            <small v-if="dealType == 'International'">(optional)</small>
          </label>
          <!-- :class="{
              'border-gray-200': !$v.form.billingAddress.zip.$invalid,
              'border-red-500': $v.form.billingAddress.zip.$invalid,
              'focus:border-gray-500': !$v.form.billingAddress.zip.$invalid,
              'focus:border-red-500': $v.form.billingAddress.zip.$invalid
            }" -->
          <input
            v-model="form.billingAddress.zip"
            v-mask="zipMask"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded mb-2 py-3 px-4 leading-tight focus:outline-none focus:bg-white"
            id="grid-billing-zip"
            type="text"
            placeholder="90291"
            autocomplete="off"
          />
          <!-- <p
            v-if="!$v.form.billingAddress.zip.required"
            class="text-red-500 text-xs italic"
          >
            Please fill out this field.
          </p> -->
          <!-- <p
            v-if="!$v.form.billingAddress.zip.minLength"
            class="text-red-500 text-xs italic"
          >
            This field must have at least 2 characters.
          </p> -->
          <!-- <p
            v-if="!$v.form.billingAddress.zip.maxLength"
            class="text-red-500 text-xs italic"
          >
            This field must have at least 10 characters.
          </p> -->
        </div>
        <div
          class="w-full md:w-1/3 px-3 md:mb-0 mt-4"
          v-if="dealType == 'Domestic' && this.form.billingAddress.country"
        >
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-billing-zip"
          >
            Country: {{ form.billingAddress.country }}
          </label>
        </div>
      </div>
    </form>
    <div v-if="content.loading" class="grid grid-cols-3 gap-4 px-8 pb-8">
      <div class="col-span-1 col-start-2 flex items-center justify-center">
        <content-placeholders class="w-full">
          <content-placeholders-img class="w-full px-8 py-4" />
        </content-placeholders>
      </div>
      <div class="col-span-1 flex items-center justify-end">
        <content-placeholders class="w-full">
          <content-placeholders-img class="w-full px-8 py-4" />
        </content-placeholders>
      </div>
    </div>
    <div v-if="content.success" class="grid grid-cols-3 gap-4 px-8 pb-8">
      <div class="col-span-1 col-start-2 flex items-center justify-center">
        <button
          @click.prevent="save()"
          :disabled="ui.loading"
          class="px-8 py-4 transition-all duration-500 ease-in-out transform hover:scale-95"
        >
          <template v-if="!actions.save.ui.loading">
            <p class="text-primary font-semibold leading-none">
              Save and close
            </p>
          </template>
          <template v-else>
            <LoadingSpinner
              class="fill-current text-primary text-opacity-75 inline-block h-3 w-6"
            />
          </template>
        </button>
      </div>
      <div class="col-span-1 flex items-center justify-end">
        <button
          @click.prevent="submit()"
          :disabled="actions.next.ui.loading"
          :class="{
            'bg-warmgrey-400': actions.next.ui.loading,
            'hover:scale-95': !actions.next.ui.loading
          }"
          class="bg-primary px-8 py-4 rounded transition-all duration-500 ease-in-out transform"
        >
          <template v-if="!actions.next.ui.loading">
            <p class="text-white font-semibold leading-none">Next</p>
          </template>
          <template v-else>
            <LoadingSpinner
              class="fill-current text-white text-opacity-75 h-3 w-6"
            />
          </template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { updateQuote } from "~/api";

import {
  required,
  requiredIf,
  maxLength,
  minLength
} from "vuelidate/lib/validators";

import { usaStates, countries, canadianStates } from "~/util/options";

export default {
  name: "CustomerInformationForm",

  data() {
    return {
      content: {
        loading: false,
        success: false,
        error: null
      },

      ui: {
        loading: false,
        success: false,
        error: null
      },

      actions: {
        back: {
          ui: {
            loading: false
          }
        },
        save: {
          ui: {
            loading: false
          }
        },
        next: {
          ui: {
            loading: false
          }
        }
      },

      options: {
        usaStates: usaStates,
        countries: countries
      },

      form: {
        contact: {
          id: null,
          firstName: "",
          lastName: null,
          email: null
        },
        account: {
          name: ""
        },
        billingAddress: {
          street: null,
          state: null,
          city: null,
          zip: null,
          country: null,
          end_use_country: ""
        }
      }
    };
  },

  validations: {
    form: {
      billingAddress: {
        street: {
          required,
          maxLength: maxLength(250),
          minLength: minLength(3)
        },
        state: {
          //required,
          maxLength: maxLength(30),
          minLength: minLength(2),
          required: requiredIf(function() {
            return this.dealType === "Domestic";
          })
        },
        city: {
          required,
          maxLength: maxLength(30),
          minLength: minLength(2)
        },
        /* zip: {
          required: requiredIf(function() {
            return this.dealType == "Domestic";
          }),
          maxLength: maxLength(10),
          minLength: minLength(2)
        }, */
        country: {
          required: requiredIf(function() {
            return this.dealType == "International";
          })
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      quoteId: "quoteForm/id",
      quoteRecord: "quoteForm/record"
    }),

    contactFullName() {
      return this.form.contact.firstName + " " + this.form.contact.lastName;
    },

    dealType() {
      return this.quoteRecord.type || "International";
    },

    zipMask() {
      let dealType = this.dealType;
      let country = this.form.billingAddress.country;
      let mask = "";
      if (dealType === "Domestic") {
        if (country === "United States") {
          mask = "XXXXX";
        } else if (country === "Canada") {
          mask = "XXXXXXX";
        }
      } else {
        mask = "XXXXXXXXX";
      }
      return mask;
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      try {
        this.content.loading = true;
        this.content.success = false;
        this.content.error = null;

        await this.set();
        setTimeout(() => {
          this.content.success = true;
          this.content.loading = false;
        }, 3000);
      } catch (error) {
        console.log(error);
        this.content.error = error;
        this.content.loading = false;
      }
    },

    set() {
      return new Promise(resolve => {
        this.form.contact.id = this.quoteRecord.contact.id;
        this.form.contact.firstName = this.quoteRecord.contact.first_name;
        this.form.contact.lastName = this.quoteRecord.contact.last_name;
        this.form.contact.email = this.quoteRecord.contact.email;
        this.form.account.name = this.quoteRecord.account_name;
        this.form.billingAddress.street = this.quoteRecord.billing_street;
        this.form.billingAddress.city = this.quoteRecord.billing_city;
        this.form.billingAddress.state = this.quoteRecord.billing_state;
        this.form.billingAddress.zip = this.quoteRecord.billing_zip;
        this.form.billingAddress.country = this.quoteRecord.billing_country;
        this.form.billingAddress.end_use_country = this.quoteRecord.end_use_country;
        resolve();
      });
    },

    async submit() {
      try {
        this.actions.next.ui.loading = true;
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = null;

        await this.validate();
        await this.updateQuote();
        await this.next();

        setTimeout(() => {
          this.ui.success = true;
        }, 3000);
      } catch (e) {
        console.error(e);
        this.ui.error = e;
      } finally {
        setTimeout(() => {
          this.ui.loading = false;
          this.actions.next.ui.loading = false;
        }, 3000);
      }
    },

    validate() {
      return new Promise((resolve, reject) => {
        if (!this.isValidForm("form")) {
          reject("Missing fields.");
          return;
        }
        resolve("All fields have been validated in Customer Information.");
      });
    },

    updateQuote() {
      return new Promise((resolve, reject) => {
        updateQuote(this.quoteId, {
          contact_id: Number(this.form.contact.id),
          billing_street: this.form.billingAddress.street,
          billing_city: this.form.billingAddress.city,
          billing_state: this.form.billingAddress.state,
          billing_zip: this.form.billingAddress.zip,
          billing_country: this.form.billingAddress.country,
          end_use_country: this.form.billingAddress.end_use_country
        })
          .then(response => {
            if (response.id) {
              resolve();
            } else {
              throw new Error("There was a problem trying to save changes.");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    async save() {
      try {
        this.actions.save.ui.loading = true;
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = null;

        await this.validate();
        await this.updateQuote();
        await this.close();

        setTimeout(() => {
          this.ui.success = true;
        }, 3000);
      } catch (e) {
        this.ui.error = e;
      } finally {
        this.ui.loading = false;
        this.actions.save.ui.loading = false;
      }
    },

    close() {
      window.Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Your progress has been saved.",
        text: "Now it's safe to close this window.",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      });
    },

    next() {
      setTimeout(() => {
        this.$router.push({
          name: "quote.terms",
          params: { id: this.quoteId }
        });
      }, 1500);
    },

    domesticStates(countryName) {
      if (countryName === "United States") {
        return usaStates;
      } else if (countryName === "Canada") {
        return canadianStates;
      }
      return [];
    }
  },

  watch: {
    "form.billingAddress.state": function(val) {
      if (val) {
        let findUsaStates = usaStates.find(u => u.value === val);
        if (findUsaStates) {
          this.form.billingAddress.country = "United States";
        } else {
          let findCanadianStates = canadianStates.find(u => u.value === val);
          if (findCanadianStates) {
            this.form.billingAddress.country = "Canada";
          } else {
            /* this.form.billingAddress.country = ""; */
          }
        }
      } else {
        this.form.billingAddress.country = this.form.billingAddress.country ? this.form.billingAddress.country : "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vue-content-placeholders-img {
  @apply h-12;
}
.vue-content-placeholders-img#text-area {
  @apply h-16;
}
.vue-content-placeholders-img.button {
  @apply w-56;
}
</style>
